import { render, staticRenderFns } from "./ContactsScreen.vue?vue&type=template&id=34eed78c&scoped=true"
import script from "./ContactsScreen.vue?vue&type=script&lang=js"
export * from "./ContactsScreen.vue?vue&type=script&lang=js"
import style0 from "./ContactsScreen.vue?vue&type=style&index=0&id=34eed78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eed78c",
  null
  
)

export default component.exports